import { RestfulProvider, RestfulReactProviderProps } from "restful-react";

interface ExtendedRestfulReactProviderProps<T> extends RestfulReactProviderProps<T> {
  children?: React.ReactNode;
}
export default function QmRestfulProvider({ children, ...props }: any) {
  return <RestfulProvider<ExtendedRestfulReactProviderProps<any>> {...props}>{children}</RestfulProvider>;
}
